export const isSameTrip = (a, b) => {
  if (!a || !b) return false;
  if (a.id && b.id) return a.id === b.id;
  return (
    a.description === b.description &&
    JSON.stringify(a.attractions) === JSON.stringify(b.attractions)
  );
};

export const getUsedTripsForCity = (
  tour,
  city,
  { stayIndex, tripIndex } = {}
) => {
  if (!tour || !city) return [];

  return tour
    .flatMap((group, gi) =>
      group.destination !== city
        ? []
        : group.trips.map((trip, ti) => ({ trip, gi, ti }))
    )
    .filter(({ gi, ti }) => !(gi === stayIndex && ti === tripIndex))
    .map(({ trip }) => trip);
};

export const isTripUsedInCity = (
  tour,
  candidate,
  city,
  editingContext = {}
) => {
  const used = getUsedTripsForCity(tour, city, editingContext);
  return used.some((trip) => isSameTrip(trip, candidate));
};

export const pickAvailableTrip = (suitableTrips, usedTrips) => {
  if (!suitableTrips?.length) return undefined;

  const available = suitableTrips.filter(
    (trip) => !usedTrips.some((used) => isSameTrip(used, trip))
  );

  return available[0] ?? suitableTrips[0];
};
